import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Categories1.css';

function Categories1({categories, idcategory, getProducts}) {

    const [subcategories, setSubcategories] = useState([]);

    useEffect(() => {
        if (categories.length > 0) {
            /*setTimeout(() => {
            const $slider = window.jQuery('.categories-list-owl');

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            $slider.slick({
                arrows: true,
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                rows: 1,
                adaptiveHeight: true,
                prevArrow: '<button type="button" class="slick-prev">‹</button>',
                nextArrow: '<button type="button" class="slick-next">›</button>',
                responsive: [
                { breakpoint: 480, settings: { slidesToShow: 1, slidesMargin: 10 }},
                { breakpoint: 768, settings: { slidesToShow: 2, slidesMargin: 10 }},
                { breakpoint: 992, settings: { slidesToShow: 2, slidesMargin: 20 }},
                { breakpoint: 1200, settings: { slidesToShow: 3, slidesMargin: 20 }},
                { breakpoint: 1500, settings: { slidesToShow: 3, slidesMargin: 30 }}
                ]
            });
            }, 300);*/

            getSubcategories(categories);
        }
    }, [categories]);

    function getSubcategories(categories) {

        let catgs = categories;

        catgs.forEach(cat => {
            if (cat.dessCategoryId == idcategory) {
                setSubcategories(cat.dess_subcategories);
            }
        });
    }

    function getProdsCateg(idsubcategory, subcategoryName) {
        getProducts(idsubcategory);
        //setSubcategoryName(subcategoryName);
    }

    const goToProductsSubcategory = (idsubcategory, nameSubcategory) => {
        //window.open('/category_products/'+idcategory);
        window.location.href = '/category_products/'+idsubcategory;
    }

    return (
        
        <>
            <div className="container">
                <div className="kreen-categories  style-01">
                    <div className='row'>
                        
                        {
                            subcategories.map(subcategory => {

                                return (
                                    <div className="col-md-4" key={subcategory.dessSubcategoryId}>
                                        <div className="categories-item rows-space-0 post-740 page type-page status-publish hentry">
                                            <div className="categories-inner">
                                                <figure className="categories-thumb">
                                                    <a onClick={()=>goToProductsSubcategory(subcategory.dessSubcategoryId, subcategory.name_subcategory)} tabIndex="-1" style={{cursor:"pointer"}}>
                                                        {
                                                            subcategory.url_img != null ?
                                                            <img src={subcategory.url_img}
                                                                    className="img-responsive attachment-370x370 size-370x370" alt="img"
                                                                    width="370"
                                                                    height="370" /> 
                                                            :
                                                            <img src="../assets/images/defaults/default-image-subcategory.jpg"
                                                                className="img-responsive attachment-370x370 size-370x370" alt="img"
                                                                width="370"
                                                                height="370" />
                                                        }
                                                    </a>
                                                </figure>
                                                <h3 className="title">
                                                    <a onClick={()=>goToProductsSubcategory(subcategory.dessSubcategoryId, subcategory.name_subcategory)} tabIndex="-1" style={{cursor:"pointer"}}>
                                                        {subcategory.name_subcategory} 
                                                    </a>
                                                </h3>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                )

                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default Categories1;